// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"aaba52fc","453":"9b41687b"}[chunkId] + ".chunk.js";
};